import React from "react";

interface HeadinngImageProps {
  heading: string;
  highlight?: string;
  apiImage?:string;
  imageSrc?: string;
  imageAlt: string;
  hrColor?: string;
  breakLine?: boolean;
}

const HeadingImage: React.FC<HeadinngImageProps> = ({
  heading,
  highlight,
  imageSrc,
  hrColor = "gray-400",
  breakLine = false,
  apiImage
}) => {
  return (
    <div>
      <h1 className="text-[#07393C] leading-tight font-lato-bold">
        {heading}
        {breakLine && <br className="hidden xl:block" />}
        <span className="text-green">{highlight}</span>
      </h1>
      <div className="mt-2">
        <hr className={`border-${hrColor} mb-4`} />
        <div className="blade-top-margin-sm">
           {apiImage && (
            <img
              src={ `${process.env.REACT_APP_LOCAL_URL}/${apiImage.replace(/\\/g, "/")}`}
               alt="Partners and Supporters"
            className="h-[300px] sm:h-full w-full object-cover"
              loading="eager"
              fetchPriority="high"
            />
          )}
            {imageSrc && (
            <img
              src={imageSrc}
               alt="Partners and Supporters"
            className="h-[300px] sm:h-full w-full object-cover"
              loading="eager"
              fetchPriority="high"
            />
          )}
          
        </div>
      </div>
    </div>
  );
};

export default HeadingImage;
